import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { DrawerContent } from '../models/drawer-content.model';

@Component({
    selector: 'lib-cdw-drawer-content',
    templateUrl: './cdw-drawer-content.component.html',
    styleUrls: ['./cdw-drawer-content.component.scss'],
    standalone: false,
})
export class CdwDrawerContentComponent implements OnInit {
  @Input() noContentMessage = '';

  @Input() contentTitle = '';

  @Input() drawerContentId = '';

  @Input() drawerContents: DrawerContent[] = [];

  @Input() deleteLabel = 'Delete';

  @Input() editLabel = 'Edit';

  @Input() disableEdit = false;

  @Input() disableDelete = false;

  @Input() hasSubtitle = false;

  @Output() deleteClicked = new EventEmitter();

  @Output() editClicked = new EventEmitter();

  public ngOnInit(): void {
    if (!this.drawerContents) {
      throw new Error('drawerContents not defined on cdw-drawer-content');
    }
    if (!this.noContentMessage) {
      throw new Error('noContentMessage not defined on cdw-drawer-content');
    }
  }

  public delete() {
    this.deleteClicked.emit(true);
  }

  public edit() {
    this.editClicked.emit(true);
  }
}
